<div class="ero-backdrop" tabindex="-1" (click)="onBackdropClick($event)" (keydown.escape)="close()">
  <div
    #panel
    class="ero-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ero-title"
    tabindex="-1"
    (keydown)="trapFocus($event)">
    <header class="ero-header">
      <h2 id="ero-title" class="ero-title">
        {{ title() | translate }}
      </h2>
      <button
        type="button"
        class="ero-close"
        [attr.aria-label]="'ERROR_REPORTING.FORM.CLOSE' | translate"
        (click)="close()">
        ×
      </button>
    </header>

    <div class="ero-body">
      <lib-error-report-form [context]="context()" [showResultTitle]="false" />
    </div>
  </div>
</div>
